module.exports = __webpack_public_path__ + "static/05-1-c7547d224581cea90097feb2fcf213e4.jpg";